// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__fPi+M","illustration":"Error_illustration__aPSNH","heading":"Error_heading__i0r4u","text":"Error_text__NzYwC"};